const SILENCE_PEAK_THRESHOLD = 1e-5;
const SILENCE_RMS_THRESHOLD = 1e-6;
/** Advisory measurements for approximate preview buffers (not Vital-accurate). */
export function measureBuffer(samples) {
    let samplePeak = 0;
    let sumSquares = 0;
    let sum = 0;
    let nonFinite = false;
    for (let i = 0; i < samples.length; i++) {
        const s = samples[i];
        if (!Number.isFinite(s)) {
            nonFinite = true;
            continue;
        }
        const abs = Math.abs(s);
        if (abs > samplePeak) {
            samplePeak = abs;
        }
        sumSquares += s * s;
        sum += s;
    }
    const n = samples.length;
    const rms = n > 0 ? Math.sqrt(sumSquares / n) : 0;
    const dc = n > 0 ? sum / n : 0;
    const silence = !nonFinite && samplePeak < SILENCE_PEAK_THRESHOLD && rms < SILENCE_RMS_THRESHOLD;
    return { samplePeak, rms, dc, silence, nonFinite };
}
//# sourceMappingURL=measure.js.map